import { render, staticRenderFns } from "./integralDetails.vue?vue&type=template&id=b337f808&scoped=true&"
import script from "./integralDetails.vue?vue&type=script&lang=js&"
export * from "./integralDetails.vue?vue&type=script&lang=js&"
import style0 from "./integralDetails.vue?vue&type=style&index=0&id=b337f808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b337f808",
  null
  
)

component.options.__file = "integralDetails.vue"
export default component.exports